import { Box, Stack } from "@mui/material";
import React from "react";
import { EquipmentCategory } from "../../Objects/EquipmentCategory";
import EquipmentDataList from "./EquipmentDataList";

export interface EquipmentCategoryListProps {
    equipmentCategoryList: EquipmentCategory[]
    hiddenDeleteEquip?: boolean
}

const EquipmentCategoryList: React.FC<EquipmentCategoryListProps> = ({
    equipmentCategoryList,
    hiddenDeleteEquip
}) => {
    return (
        <Stack
            spacing={4}
        >
            {equipmentCategoryList.map(equipmentCategory => (
                <Box key={equipmentCategory.equcate_id}>
                    <EquipmentDataList
                        equipmentCategory={equipmentCategory}
                        hiddenDeleteEquip={hiddenDeleteEquip}
                    />
                </Box>
            ))}
        </Stack>
    )
}

export default EquipmentCategoryList